import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Divider, IconToggleButton, Image, cn } from "@pcln/horizon";
import { recentSelectionVariants } from "../../RecentSelection.variants.js";
import { CTAButtons, DateBlock, OccupancySection } from "../../common/shared.js";
const TRIP_TYPE_LABELS = {
    MULTI_DESTINATION: 'Multi-city',
    ONE_WAY: 'One-way',
    ROUND_TRIP: 'Round-trip'
};
function toTripTypeLabel(tripType) {
    if (!tripType) return;
    return TRIP_TYPE_LABELS[tripType] ?? tripType;
}
function FlightSelection({ buttonText = 'Continue Search', cabinClass, className, departFlight, headline, isFavorite, numAdults, occupancyText, onClick, onFavoriteToggle, returnFlight, subtitle: subtitleText, tripType }) {
    const resolvedPassengerCount = 'number' == typeof numAdults && Number.isFinite(numAdults) && numAdults > 0 ? numAdults : 1;
    const resolvedCabinClass = cabinClass || 'Economy';
    const resolvedOccupancyText = occupancyText ?? `${resolvedPassengerCount} Adult${1 === resolvedPassengerCount ? '' : 's'}, ${resolvedCabinClass}`;
    const mappedTripType = toTripTypeLabel(tripType);
    const resolvedSubtitle = subtitleText ?? (mappedTripType ? `${mappedTripType} flight` : 'Flight');
    const { attributeRow, bottomSection, card, contentWrapper, dateBlockDividerHorizontal, dateBlockDividerVertical, dateBlocksContainer, favoriteButton, imageContainer, infoSection, middleSection, root, subtitle, title, topSection } = recentSelectionVariants({
        productType: 'flight'
    });
    const flightIcon = 'https://s1.pclncdn.com/design-assets/brand-assets/product-icons/flights.svg';
    return /*#__PURE__*/ jsx("div", {
        className: cn(root(), className),
        children: /*#__PURE__*/ jsx("div", {
            className: card(),
            onClick: onClick,
            children: /*#__PURE__*/ jsxs("div", {
                className: contentWrapper(),
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: topSection(),
                        children: [
                            onFavoriteToggle && /*#__PURE__*/ jsx("div", {
                                className: favoriteButton(),
                                children: /*#__PURE__*/ jsx(IconToggleButton, {
                                    ariaLabel: "Favorite this flight",
                                    emphasis: "bold",
                                    isAnimated: true,
                                    isToggledOn: isFavorite,
                                    onToggle: onFavoriteToggle,
                                    palette: "favorite",
                                    size: "24"
                                })
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: cn(imageContainer(), 'flex items-center justify-center rounded-xl'),
                                children: /*#__PURE__*/ jsx(Image, {
                                    alt: "Flight Icon",
                                    height: 12,
                                    src: flightIcon,
                                    width: 12
                                })
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: infoSection(),
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: title(),
                                        children: headline
                                    }),
                                    /*#__PURE__*/ jsx("div", {
                                        className: attributeRow(),
                                        children: /*#__PURE__*/ jsx("div", {
                                            className: subtitle(),
                                            children: resolvedSubtitle
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: middleSection(),
                        children: [
                            /*#__PURE__*/ jsxs("div", {
                                className: dateBlocksContainer(),
                                children: [
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        airportCodes: departFlight.airportCodes,
                                        dateInfo: departFlight.dateInfo,
                                        label: "Depart",
                                        productType: "flight"
                                    }),
                                    returnFlight && /*#__PURE__*/ jsxs(Fragment, {
                                        children: [
                                            /*#__PURE__*/ jsx(Divider, {
                                                className: dateBlockDividerVertical(),
                                                direction: "vertical"
                                            }),
                                            /*#__PURE__*/ jsx(Divider, {
                                                className: dateBlockDividerHorizontal(),
                                                direction: "horizontal"
                                            }),
                                            /*#__PURE__*/ jsx(DateBlock, {
                                                airportCodes: returnFlight.airportCodes,
                                                dateInfo: returnFlight.dateInfo,
                                                label: "Return",
                                                productType: "flight"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: bottomSection(),
                                children: [
                                    /*#__PURE__*/ jsx(OccupancySection, {
                                        iconName: "person",
                                        text: resolvedOccupancyText
                                    }),
                                    /*#__PURE__*/ jsx(CTAButtons, {
                                        buttonText: buttonText,
                                        onClick: onClick
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
export { FlightSelection };
